module.exports = __webpack_public_path__ + "static/media/tsb2kz.01adfd27.pdf";